const getFormattedDate = (daysToAdd = 0) => {
	const MILLISECONDS_PER_DAY = 86400000

	// вичисляємо Timestamp для дати
	const targetTimestamp = Date.now() + daysToAdd * MILLISECONDS_PER_DAY
	// повертаємо відформатовану дату у форматі YYYY-MM-DD
	return new Date(targetTimestamp).toISOString().slice(0, 10)
}

export default getFormattedDate
